import React from 'react'
import { Path, G, Defs, LinearGradient, Stop, ClipPath, Rect } from 'react-native-svg'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { svgIdentifier } from 'ui/svg/utils'

import { AccessibleRectangleIcon } from '../types'

export const ArtsCrafts: React.FunctionComponent<AccessibleRectangleIcon> = ({
  accessibilityLabel,
  testID,
  width = 156,
  height = 92,
}) => {
  const { id: clipPathId, fill: clipPath } = svgIdentifier()
  const { id: gradientId, fill: gradientFill } = svgIdentifier()

  return (
    <AccessibleSvg
      width={width}
      height={height}
      viewBox="0 0 156 92"
      fill="none"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <G clipPath={clipPath}>
        <G>
          <Path
            d="M40.3462 73.2232C40.5749 76.1671 37.8496 78.6941 34.2598 78.8602C30.67 79.0262 27.5764 76.7693 27.3477 73.8255C27.119 70.8816 29.8443 68.3546 33.4341 68.1885C37.0179 68.024 40.116 70.2734 40.3462 73.2232Z"
            fill="#D63D00"
          />
        </G>
        <Path
          d="M26.2528 14.265C2.36394 20.5274 -12.9908 40.8974 -8.04525 59.7631C-3.09972 78.6287 20.2734 88.8465 44.1623 82.5841C44.7128 82.4398 45.2556 82.2911 45.7954 82.1304C49.049 81.175 51.0514 77.6911 50.3936 74.0719C50.3505 73.8335 50.3134 73.5934 50.2763 73.3533C49.1363 65.4285 53.2135 57.75 60.063 54.9745C63.5806 53.5464 67.2415 53.5282 70.5699 54.6092C74.4061 55.8516 78.2994 53.2426 78.9858 49.0789C79.6392 45.1096 79.5035 41.0654 78.4603 37.0861C73.5148 18.2204 50.1416 8.00269 26.2528 14.265ZM41.0825 71.1072C41.3112 74.0511 38.5859 76.578 34.9961 76.7441C31.4063 76.9102 28.3127 74.6533 28.084 71.7094C27.8554 68.7655 30.5806 66.2386 34.1705 66.0725C37.7603 65.9064 40.8523 68.1573 41.0825 71.1072Z"
          fill="white"
        />
        <Path
          d="M26.2528 14.265C2.36394 20.5274 -12.9908 40.8974 -8.04525 59.7631C-3.09972 78.6287 20.2734 88.8465 44.1623 82.5841C44.7128 82.4398 45.2556 82.2911 45.7954 82.1304C49.049 81.175 51.0514 77.6911 50.3936 74.0719C50.3505 73.8335 50.3134 73.5934 50.2763 73.3533C49.1363 65.4285 53.2135 57.75 60.063 54.9745C63.5806 53.5464 67.2415 53.5282 70.5699 54.6092C74.4061 55.8516 78.2994 53.2426 78.9858 49.0789C79.6392 45.1096 79.5035 41.0654 78.4603 37.0861C73.5148 18.2204 50.1416 8.00269 26.2528 14.265ZM41.0825 71.1072C41.3112 74.0511 38.5859 76.578 34.9961 76.7441C31.4063 76.9102 28.3127 74.6533 28.084 71.7094C27.8554 68.7655 30.5806 66.2386 34.1705 66.0725C37.7603 65.9064 40.8523 68.1573 41.0825 71.1072Z"
          fill={gradientFill}
        />
        <Path
          d="M62.0247 27.4153C62.1096 28.8982 60.703 30.9065 58.6167 31.0371C56.5304 31.1677 55.591 29.9025 55.5062 28.4196C55.4213 26.9367 54.4409 24.5038 56.5272 24.3732C58.6058 24.2381 61.9399 25.9324 62.0247 27.4153Z"
          fill="#D63D00"
        />
        <Path
          d="M21.7194 30.1131C23.3955 32.3637 23.9815 36.7446 18.8528 37.0579C15.2634 37.2751 13.0433 40.989 11.3672 38.7384C9.69105 36.4878 10.3945 31.8713 13.2887 29.742C16.1828 27.6127 20.0433 27.8625 21.7194 30.1131Z"
          fill="#D63D00"
        />
        <Path
          d="M33.9676 20.8331C35.3622 19.1738 38.0448 19.5914 39.7148 21.6707C41.4323 23.808 43.7207 23.5603 42.326 25.2197C40.9314 26.879 37.3177 28.9023 35.1975 27.1524C33.0788 25.4085 32.5746 22.4985 33.9676 20.8331Z"
          fill="#D63D00"
        />
        <Path
          d="M5.86886 56.0234C7.49066 58.6341 11.8279 61.6217 8.65921 63.5668C5.49053 65.5118 0.359736 63.7434 -1.26206 61.1327C-2.88386 58.522 -2.79314 52.5547 0.375539 50.6096C3.54422 48.6645 4.24706 53.4128 5.86886 56.0234Z"
          fill="#D63D00"
        />
      </G>
      <Defs>
        <LinearGradient
          id={gradientId}
          x1={35.4386}
          y1={27.2097}
          x2={-44.2014}
          y2={94.9814}
          gradientUnits="userSpaceOnUse">
          <Stop stopColor="white" />
          <Stop offset={1} stopColor="#FFAD8D" />
        </LinearGradient>
        <ClipPath id={clipPathId}>
          <Rect width={156} height={92} fill="white" />
        </ClipPath>
      </Defs>
    </AccessibleSvg>
  )
}
